import { Navigate, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";
import { useUser } from "../../contexts/UserProvider";
import { use } from "react";

export default function PrivateRoute({ children }) {
  const { user } = useUser();
  const location = useLocation();
  const user_consent = useSelector((state) => state.user.consent);
  const pre_survey = useSelector((state) => state.user.presurvey_form);
  const url = location.pathname + location.search + location.hash;

  console.log(user);

  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" state={{ next: url }} />;

  console.log(user_consent.submitted, pre_survey.submitted);

  if (
    // must have both consent AND presurvey submitted
    (!user_consent.submitted || !pre_survey.submitted) &&
    location.pathname !== "/prior"
  ) {
    return <Navigate to="/prior" state={{ next: url }} />;
  }

  return children;
}